import { type Edge } from '@xyflow/react'

export const buildEdge = (
  id: string,
  source: string,
  target: string,
  label: string,
  animated?: boolean,
  isLightMode?: boolean,
): Edge => ({
  id,
  source,
  target,
  animated,
  style: {
    fontSize: 20,
    stroke: animated
      ? isLightMode
        ? '#4caf50'
        : '#6bf66b'
      : isLightMode
        ? '#b2b2b2'
        : '#7b7989',
    strokeWidth: 2,
  },
  data: {
    label,
  },
})
